// Copyright (c) PikPok. All rights reserved
import {createStore} from "vuex";
import {supportStore} from './store/store'

export default createStore({
  modules: {
    supportStore: supportStore
  },
})